module.exports = __webpack_public_path__ + "media/investment_locations/germany-map-83297287.webp";